<template>
  <div >



    <line-chart
      :chart-data="datacollection"
      :options = "options"
      :triggerChange="triggerChange"
    ></line-chart>
  
  </div>
</template>

<script>
  /* eslint-disable */
  import LineChart from './LineChart.js'


  export default {
    components: {
      LineChart
    },
    props:{
       datacollection :   {
            labels: [],
            datasets:[]
      },
      options : null,
      triggerChange:true
     },
    watch: {

      'datacollection.labels': function (val) {
        // console.log('from watch chart datacollection.labels')
        // console.log(val)

      }
    },

    data () {
       return {
         // datacollection:  {
         //   labels:  [ "22-Nov-2019", "21-Nov-2019", "20-Nov-2019", "19-Nov-2019", "18-Nov-2019", "17-Nov-2019", "16-Nov-2019", "15-Nov-2019", "14-Nov-2019", "13-Nov-2019", "12-Nov-2019" ],
         //   datasets: [{
         //     "backgroundColor": 'rgba(0, 150, 0, 0.1)',
         //     "data":  [ 275, 234, 317, 280, 242, 246, 269, 213, 316, 323, 394 ]
         //   }]
         // },
         // options : null
      //   PCV: [], //[0,1,2,3,4,5,6,7,8,9],
      //   BUN: [], // [9,8,7,6,5,4,3,2,1,0],
      //   CRETITNIE: [] , //[4,5,4,5,4,5,4,5,4,15],
      //   time: ['1/1/20','2/1/20','3/1/20','4/1/20','5/1/20','6/1/20','7/1/20','8/1/20','9/1/20','10/1/20']
      }
    },
     mounted () {
      // console.log("mount from chart")
      // this.PCV = this.getRandomIntAsArray()
      // this.BUN = this.getRandomIntAsArray()
      // this.CRETITNIE = this.getRandomIntAsArray()
      // this.fillData()

    },
    methods: {
      // fillData () {
      //   this.datacollection = {
      //     labels: this.time,
      //     datasets: [
      //       {
      //         label: 'PCV',
      //         backgroundColor: 'rgba(0, 0, 255, 0.1)',
      //         borderColor: 'lightblue',
      //         pointBackgroundColor: 'blue',
      //         borderWidth: 1,
      //         pointBorderColor: 'blue',
      //         // data: [1,2,3,2,1,3,4,6,7,8],
      //         data: this.PCV
      //       },
      //       {
      //         label: 'BUN',
      //         backgroundColor: 'rgba(255, 0, 0, 0.1)',
      //         borderColor: 'lightpink',
      //         pointBackgroundColor: 'red',
      //         borderWidth: 1,
      //         pointBorderColor: 'red',
      //         // data: [6,7,6,8,7,8,6,7,6,6]
      //         data: this.BUN
      //       },
      //       {
      //         label: 'CRETINENE',
      //         backgroundColor: 'rgba(255, 255, 0, 0.1)',
      //         borderColor: 'rgba(0,102,255,0.5)',
      //         pointBackgroundColor: 'orange',
      //         borderWidth: 1,
      //         pointBorderColor: 'orange',
      //         // data: [6,7,6,8,7,8,6,7,6,6]
      //         data: this.CRETITNIE
      //       }
      //     ]
      //   }
      // }
      // ,
      //   getRandomInt () {
      //     return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      //   }
      // , getRandomIntAsArray(){
      //     var a = []
      //     for(var i=0;i<this.time.length;i++){
      //       a.push(this.getRandomInt())
      //     }
      //
      //     return a
      // }
      //
    
      
      
    }
  }
</script>

<style>
  /*.small {*/
  /*  width: 500px;*/
  /*  height: 100px;*/
  /*  margin: auto*/
  /*}*/
</style>